/**
 * Address completion settings widget script
 */
import utils from '../utils';
import Vue from 'vue/dist/vue';
import ui from "../ui";

require('./vue/select2');

/**
 * Initialization of Vue for address completion settings
 * inside a container
 * @param {jQuery} $container
 */
const initializeContainer = function($container) {
    $container.find('[data-address-completion-settings-widget]').each(function() {
        let $addressCompletionSettingsWidget = $(this);
        if ($addressCompletionSettingsWidget.hasClass('initialized')) {
            return;
        }

        let defaults = {
            settings:      [],
            property:      '',
            fieldOptions:  {},
            emptySettings: {},
        };

        let id = utils.uniqueID($addressCompletionSettingsWidget);

        // Update the template to bind
        utils.vueBind($addressCompletionSettingsWidget.find('[id], [name], [for]'), ['id', 'name', 'for']);

        let vm = new Vue({
            el:      `#${id}`,
            data:    $.extend(defaults, $addressCompletionSettingsWidget.data('address-completion-settings-widget')),
            mounted: function() {
                ui.initializeContainer($(this.$el));
            },
            updated: function() {
                ui.initializeContainer($(this.$el));
            },
        });

        $addressCompletionSettingsWidget.addClass('initialized').data('vm', vm);
    });
};

// Export initialization
export default {
    initializeContainer: initializeContainer,
};


// WEBPACK FOOTER //
// ./plugins/Admin/build/script/src/components/address_completion_settings.js